import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const AnnouncementBar = () => (
    <Link
        to="/committees#c-ipl-auction"
        data-testid="ipl-announcement-bar"
        className="group relative block overflow-hidden border-y border-crimson/40 bg-maroon/30"
    >
        <div
            aria-hidden="true"
            className="absolute inset-0 bg-[radial-gradient(ellipse_60%_120%_at_90%_50%,rgba(201,31,38,0.18),transparent_65%)]"
        />
        <div className="relative mx-auto flex max-w-[1400px] flex-col items-start gap-3 px-5 py-5 md:flex-row md:items-center md:justify-between md:px-10">
            <div className="flex flex-wrap items-center gap-4">
                <span className="bg-crimson px-3 py-1 font-sans text-[9px] font-bold uppercase tracking-[0.3em] text-cream">
                    New
                </span>
                <p className="font-serif text-xl font-light italic leading-snug text-cream md:text-2xl">
                    The IPL Auction — build your dream squad.
                </p>
            </div>
            <div className="flex flex-wrap items-center gap-x-6 gap-y-2 font-sans text-[10px] font-semibold uppercase tracking-[0.25em] text-ash">
                <span>₹3,000 per team</span>
                <span className="text-scarlet">₹20,000 in prizes</span>
                <span className="inline-flex items-center gap-2 text-cream transition-colors duration-300 group-hover:text-scarlet">
                    Register
                    <ArrowRight className="h-3.5 w-3.5 text-scarlet transition-transform duration-300 group-hover:translate-x-1" />
                </span>
            </div>
        </div>
    </Link>
);

export default AnnouncementBar;
